/*
  BONUS: pune automat setul de roți în coș când există un scaun eligibil.

  Reducerea automată din Shopify („cumperi scaunul, primești roțile la 0") face prețul, dar
  NU adaugă produsul — clientul ar fi trebuit să caute singur roțile ca să primească bonusul
  promis pe pagina scaunului. Scriptul ăsta închide golul.

  Trei garduri, în ordinea în care contează:

  1. Dacă omul ȘTERGE roțile din coș, nu i le punem la loc în aceeași sesiune. Un cadou care
     reapare după ce l-ai scos nu mai e cadou, e insistență. Steagul stă în sessionStorage,
     deci la vizita următoare primește din nou șansa.
  2. Nu adăugăm niciodată mai mult de un set, oricâte scaune ar fi în coș — reducerea e
     oricum limitată la unul pe comandă.
  3. `busy` oprește bucla: propria noastră adăugare declanșează la rândul ei cartUpdate.

  Configurația (ID-urile de variantă) vine din Liquid, nu e scrisă aici — vezi
  snippets/gift-wheels-cart.liquid.
*/
(function () {
  var cfg = window.ERG_GIFT;
  if (!cfg || !cfg.giftId || !cfg.qualifyingIds || !cfg.qualifyingIds.length) return;

  var SKIP_KEY = 'erg_gift_declined';
  var busy = false;
  var sawGift = false;

  function declined() {
    try { return sessionStorage.getItem(SKIP_KEY) === '1'; } catch (e) { return false; }
  }
  function decline() {
    try { sessionStorage.setItem(SKIP_KEY, '1'); } catch (e) {}
  }

  function check() {
    if (busy || declined()) return;
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js',
          { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var hasGift = items.some(function (i) { return i.variant_id === cfg.giftId; });
        var hasChair = items.some(function (i) { return cfg.qualifyingIds.indexOf(i.variant_id) !== -1; });

        // Gardul 1: era în coș, nu mai e, iar scaunul a rămas -> omul l-a scos intenționat.
        if (sawGift && !hasGift && hasChair) { decline(); return; }
        sawGift = hasGift;

        if (!hasChair || hasGift) return;

        busy = true;
        return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: cfg.giftId, quantity: 1 }] })
        })
          .then(function () {
            sawGift = true;
            // Reîmprospătăm coșul vizibil, fără să republicăm cartUpdate (ar reintra aici).
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.renderContents === 'function') {
              return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') +
                           '?sections=' + (cfg.drawerSection || 'cart-drawer'))
                .then(function (r) { return r.json(); })
                .then(function (s) { drawer.renderContents({ sections: s }); })
                .catch(function () {});
            }
            if (cfg.isCartPage) window.location.reload();
          })
          .catch(function () {})
          .then(function () { busy = false; });
      })
      .catch(function () { busy = false; });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    if (cfg.cartHasItems) check();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(check, 120); });
    }
  });
})();
